export const cleanUserTokensFromLocalStorage = () => {
  localStorage.removeItem("accessToken");
  localStorage.removeItem("refreshToken");
  localStorage.removeItem("sessionToken");
};

export const setUserTokensToLocalStorage = (accessToken: string, refreshToken: string, sessionToken: string) => {
  localStorage.setItem("accessToken", accessToken);
  localStorage.setItem("refreshToken", refreshToken);
  localStorage.setItem("sessionToken", sessionToken);
};

export const getIsAuthenticated = () => !!localStorage.getItem("accessToken");

export const getAccessToken = () => localStorage.getItem("accessToken");

export const getRefreshToken = () => localStorage.getItem("refreshToken");

export const getSessionToken = () => localStorage.getItem("sessionToken");

export const copyQrCodeToNavigator = async (text: string) => {
  try {
    if (!text?.length) return false;

    await navigator.clipboard.writeText(text);

    return true;
  } catch (e) {
    return false;
  }
};
